import React from 'react';

export const PromotionText = ({ text, className, onClick }) =>
    <div dangerouslySetInnerHTML={{ __html: text }} className={className} onClick={onClick}></div>;
